"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dev_to = void 0;
var types_1 = require("../types");
exports.dev_to = {
    name: 'dev_to',
    matches: [
        {
            match: '(https?://)?(www.)?dev.to/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://dev.to/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
//# sourceMappingURL=dev_to.js.map